import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Card,
  Form,
  Button,
  InputGroup,
} from "@themesberg/react-bootstrap";
import axios from "axios";
import {
  createContract,
  getContract,
  updateContract,
  getVendorList,getFetchTemplate,
  getFetchContractsCounts
} from "../../app/api";
import Select from "react-select";
import { useParams } from "react-router-dom";
import Loader from "../../components/Loader";
import swal from "sweetalert";
import { useHistory,useLocation } from "react-router-dom";
import { Routes } from "../../routes";
import moment from "moment-timezone";
import Datetime from "react-datetime";
import Loadericon from "../../components/Loadericon";
import {useFetchContractsAuthQuery} from '../../store/app/apislice'
export default () => {
  const { id } = useParams();
  const {access_token}=useParams()
  const location = useLocation();
  const history = useHistory();
  const [title, setTitle] = useState("");
  const [vendor, setVendor] = useState([]);
  const [Loading, setLoading] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [vendorId, setVendorID] = useState("");
  const [expiry, setExpirydate] = useState("");
  const [shouldFetch, setShouldFetch] = useState(false);
  const[template,setTemplate]=useState([])
  const [templateId, setTemplateID] = useState("");
  const [selectedTemplateInfo, setSelectedTemplateInfo] = useState({ id: '', name: '' });
  const accesstoken = localStorage.getItem("adobe_access_token");
  const adobe_token_issued_at=localStorage.getItem("adobe_token_issued_at");
  const [confirmText, setConfirmText] = useState('');
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [validationError, setValidationError] = useState('');
  const [contractsCounts,setContractsCounts] = useState("");
  const [contractsTodayCounts,setContractsTodayCounts] = useState("");
  const handleChange = (e) => {
    const selectedValue = e.target.value;
    try {
      const templateInfo = JSON.parse(selectedValue);
      setSelectedTemplateInfo(templateInfo);
      console.log('Selected Template ID:', templateInfo.id);
      console.log('Selected Template Name:', templateInfo.name);
    } catch (error) {
      setSelectedTemplateInfo({ id: '', name: '' });
      setTemplateID('');
    }
  };
  useEffect(() => {
    const hash = location.hash; // e.g., "#access_token=3AAABLblqZhD2vRSUmuDw6JXK5MJ4cgxdpjExfH8ndI-iZ9fSfplMpySpyKhyx_rbAWQDtSf49nc9oxPnvDrxuNnJ6IqrO2bq"
    const params = new URLSearchParams(hash.substring(1)); // Remove the '#' and parse the hash
    const accessToken = params.get("access_token");
    const adobe_token_issued_at = params.get("adobe_token_issued_at");
   
    if (accessToken) {
      // console.log("Access Token:", accessToken);

     
      localStorage.setItem("adobe_access_token", accessToken);
      localStorage.setItem("adobe_token_issued_at", adobe_token_issued_at);

      const cleanUrl = location.pathname; // Get the URL without the hash
      history.replace(cleanUrl);
    } else {
      console.error("Access token not found in the URL.");
    }
  }, [location,history]);
  const handleBeforeSubmit = async () => {
  
    const handleContractsCounts = async() => {
      try {
        const token = localStorage.getItem("token");
  
        const response = await axios.get(getFetchContractsCounts(), {
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });
        console.log(response);
        setContractsCounts(response?.data?.total_agreements_count);
        setContractsTodayCounts(response?.data?.todays_agreements_count);
        console.log(response?.data?.total_agreements_count);
        console.log(response?.data?.total_agreements_count);
      } catch (error) {
        console.log("error while fetching templates", error);
        throw error; 
      }
    };
    setShowConfirmation(true);
    try {
      const templateData = await handleContractsCounts();
      console.log("Template data fetched successfully:", templateData);
      return true; 
    } catch (error) {
      console.error("Error during before-submit actions:", error);
      return false; 
    }
    if (!title.trim()) {
      swal({ text: "Please enter a title.", icon: "warning" });
      return;
    }

    if (!vendorId && !id) { 
      swal({ text: "Please select a vendor.", icon: "warning" });
      return;
    }

    if (!expiry) {
      swal({ text: "Please select an expiry date.", icon: "warning" });
      return;
    }

    if (!selectedTemplateInfo.id && !id) { 
      swal({ text: "Please select a template.", icon: "warning" });
      return;
    }

   
  };

  const handleConfirmationChange = (e) => {
    setConfirmText(e.target.value);
    setValidationError('');
  };

  const handleConfirmSubmit = () => {
    if (confirmText.toLowerCase() === 'confirm') {
      handleSubmit();
      setShowConfirmation(false);
    } else {
      setValidationError('Please type "confirm" to proceed.');
    }
  };

  useEffect(()=>{
    handleAdobelink();
  },[])
  const handleAdobelink = async() => {
    try {
     
      const token = localStorage.getItem("token");
      
     
      const response = await axios.get(getFetchTemplate(), {
        headers: {
        },
      });
      console.log(response?.data?.data);
      setTemplate(response?.data?.data)
    } catch (error) {
      console.log("error while fetching templates")
    } 
   
  };
  const handleSubmit = async () => {
    try {
      setLoadingBtn(true);
      const access_token = localStorage.getItem("adobe_access_token");

      const token = localStorage.getItem("token");
      const formattedToDate = moment(expiry).format("YYYY-MM-DD HH:mm:ss");
      const assetData = {
        title,
        vendor_id: vendorId,
        expiration_date: formattedToDate,
        // template_id:templateId
        template_id: selectedTemplateInfo.id,
        template_name: selectedTemplateInfo.name,
      };

      let response;

      if (id) {
        response = await axios.put(updateContract(id), assetData, {
          headers: {
            "Content-Type": "application/json",
            "secret-key": process.env.REACT_APP_SECRET_KEY,
            "auth-token": `Bearer ${token}`,
          
          },
        });
        swal({
          text: response.data.message,
          icon: "success",
        }).then(() => {
          history.push(Routes.Contracts.path);
        });
      } else {
        response = await axios.post(createContract(), assetData, {
          headers: {
            "Content-Type": "application/json",
            "secret-key": process.env.REACT_APP_SECRET_KEY,
            "auth-token": `Bearer ${token}`,
            "accessToken":access_token
          },
        });
        swal({
          text: response.data.message,
          icon: "success",
        });
       
          setTitle("");
          setExpirydate("");
          setVendorID("");
      
      }

      // console.log(response.data);
    } catch (err) {
      swal({
        text: err.response.data.messages.error,
        icon: "error",
      });
    } finally {
      setLoadingBtn(false);
   
    }
  };

  const fetchSingleContracts = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(getContract(id), {
        headers: {
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
        },
      });
      // console.log(response.data);
      setTitle(response.data?.data?.title);

      setVendorID(response.data?.data?.vendor_id);
      setExpirydate(response.data?.data?.expiration_date);
    } catch (error) {
      // console.error("Error fetching vendors:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchSingleContracts();
  }, [id]);
  useEffect(() => {
    const fetchvendorsList = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("token");
        const response = await axios.get(getVendorList(), {
          headers: {
            "secret-key": process.env.REACT_APP_SECRET_KEY,
            "auth-token": `Bearer ${token}`,
          },
        });
        // console.log("vendor dropdown", response.data?.data);
        setVendor(response.data?.data);
      } catch (error) {
        // console.error("Error fetching vendors:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchvendorsList();
  }, []);
  const handleBackClick = () => {
    history.push(Routes.Contracts.path);
  };
  const vendorList = vendor.map((v) => ({
    value: v.id,
    label: v.company_name,
  }));
  return (
    <>
      {Loading ? (
        <Loader />
      ) : (
        <div>
          <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-2">
            <div className="d-block  mb-md-0">
              <h4 className="mb-0">Contract</h4>
            </div>
          </div>

          <Row className="justify-content-md-center">
            <Col xs={12} sm={12} xl={12} lg={12} className="mb-4">
              <Card border="light" className="shadow-sm custom-card ">
                <Card.Body>
                  <Card.Title>
                    {id ? "Update Contract" : "Create a New Contract"}
                  </Card.Title>

                  <Form onSubmit={(e) => e.preventDefault()}>
                    <Row>
                      <Col md={6} className="mb-3">
                        <Form.Group id="Title">
                          <Form.Label>Title</Form.Label>
                          <Form.Control
                            required
                            type="text"
                            placeholder="Enter Title"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                      {/* <Col md={6} className="mb-3">
                        <Form.Group id="Vendor Name">
                          <Form.Label>Vendor Name</Form.Label>
                          <Form.Select
                            value={vendorId}
                            onChange={(e) => setVendorID(e.target.value)}
                          >
                            <option value="0">Select Vendor</option>
                            {vendor?.map((v) => (
                              <option key={v.id} value={v.id}>
                                {v.company_name}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col> */}
                      {id ?(null):(
                                                              <Col md={6} className="mb-3">
                                                              <Form.Group id="Vendor Name">
                                                              <Form.Label>Vendor Name</Form.Label>
                                                              <Select
                                                            
                                                          options={vendorList}
                                                          placeholder="Select Vendor"
                                                          value={
                                                            vendorList.find((option) => option.value === vendorId) ||
                                                            null
                                                          }
                                                         
                                                          onChange={(selectedOption) => {
                                                            setVendorID(selectedOption.value);
                                                          }}
                                                          styles={{
                                                            container: (base) => ({
                                                              ...base,
                                                              borderRadius: "5px",
                                                              width: "100%",
                                                            }),
                                                          }}
                                                        />
                                                        </Form.Group>
                                                        </Col>

                      )}
                       
                    </Row>
                    
                    <Row>
                    {id?(null):(
                      <>
                           <Col md={6} className="mb-3">
                           <Form.Group id="Select Template">
      <Form.Label>Select Template</Form.Label>
      <Form.Select
        value={JSON.stringify(selectedTemplateInfo)} // Set the entire object as value
        onChange={handleChange}
        disabled={id}
      >
        <option value={JSON.stringify({ id: '', name: 'Select Template' })}>
          Select Template
        </option>
        {template.map((v) => (
          <option key={v.id} value={JSON.stringify({ id: v.id, name: v.name })}>
            {v.name}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
                         </Col>
                         </>
                      )}
                 
                      <Col md={6} className="mb-3">
                        <Form.Group id="Expiry Date">
                          <Form.Label>Expiry Date</Form.Label>
                          <Datetime
                          className="datepicker"
                            timeFormat={false}
                            onChange={(e) => setExpirydate(e)}
                            renderInput={(props, openCalendar) => (
                              <InputGroup>
                                <InputGroup.Text>
                                  <FontAwesomeIcon icon={faCalendarAlt} />
                                </InputGroup.Text>
                                <Form.Control
                                  required
                                  type="text"
                                  value={
                                    expiry
                                      ? moment(expiry).format("MM/DD/YYYY")
                                      : ""
                                  }
                                  placeholder="mm/dd/yyyy"
                                  onFocus={openCalendar}
                                  onChange={() => {}}
                                  inputProps={{ className: "date-picker-input" }} 
                                />
                              </InputGroup>
                            )}
                          />
                        </Form.Group>
                      </Col>
                      
                    </Row>
                    <div className="d-flex justify-content-between">
                      <Button
                        variant="primary"
                        onClick={handleBackClick}
                        className=" me-2"
                      >
                        <span>Back</span>
                      </Button>
                      {loadingBtn ? (
                        <div className="d-flex justify-content-start">
                          <Loadericon />
                        </div>
                      ) : (
                        <Button
                          variant="primary"
                          // type="submit"
                          onClick={handleBeforeSubmit}
                          className=" me-2"
                        >
                          <span>Save</span>
                        </Button>
                      )}
                    </div>
                    {showConfirmation && (
        <div className="modal show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Action</h5>
                <button type="button" className="btn-close" onClick={() => setShowConfirmation(false)} aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <p>Please type "confirm" (case-insensitive) to proceed with saving.</p>
                <h6 className="mb-0">Total Contracts: <span className="small">{contractsCounts}</span></h6>
        <h6 className="mb-0 mt-2">Total Today's Contracts: <span className="small">{contractsTodayCounts}</span></h6>
                <Form.Control
                  type="text"
                  placeholder="Type 'confirm' here"
                  value={confirmText}
                  onChange={handleConfirmationChange}
                />
                {validationError && <Form.Text className="text-danger">{validationError}</Form.Text>}
              </div>
              <div className="modal-footer">
                <Button variant="secondary" onClick={() => setShowConfirmation(false)}>Cancel</Button>
                <Button variant="primary" onClick={handleConfirmSubmit} disabled={loadingBtn}>
                  {loadingBtn ? 'Saving...' : 'Confirm Save'}
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
};
